module.exports = __webpack_public_path__ + "img/KSC02772.1989ac7e.jpg";